import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classes from './DecisionSingleValueTemplate.module.scss'
import clsx from 'clsx'

interface DecisionSingleValueTemplateProps {
  attribute: any
  value: string
  isGrouped: boolean
}

const DecisionSingleValueTemplate = (props: DecisionSingleValueTemplateProps) => {
  return (
    <div className={classes['decision-single-value-item']}>
      <span>
        <span
          className={clsx({
            [classes['decision-single-value-item-header-grouped']]: props.isGrouped,
          })}
        >
          {props?.attribute.display_name}
        </span>
        {props?.attribute?.help_text && (
          <FontAwesomeIcon
            icon={faInfoCircle}
            title={props?.attribute?.help_text}
            className={classes['decision-single-value-item-icon']}
          />
        )}
      </span>
      <div
        className={clsx({
          [classes['decision-single-value-item-answer']]: !props.isGrouped,
        })}
      >
        {props.value}
      </div>
    </div>
  )
}

export default DecisionSingleValueTemplate
